import axiosJava from "@/api/config_java";
// import qs from 'qs'
// 样例
export const indexConfig = data => axiosJava.get(`/am/api/homePage/data`);
export const getWalletData = data => axiosJava.get(`/am/api/homePage/walletData`);
export const closeHelp = data => axiosJava.get(`/am/api/homePage/close?id=${data}`);
export const littleHelper = (pageNum, pageSize, isShow, type) =>
  axiosJava.get(
    `/am/api/homePage/helper?pageNum=${pageNum}&pageSize=${pageSize}&isShow=${isShow}&type=${type}`
  );

export const closeSingleHelper = id =>
  axiosJava.get(`/am/api/homePage/close?id=${id}`);

export const getClientPlatformStatus = param => axiosJava.get(`/am/api/clientCompany/queryMedia`);
